module.exports = __webpack_public_path__ + "static/media/rejected.2a5e8240.svg";